export enum ActionRoutes {
	New = 'new',
	Update = 'update',
	Create = 'create',
	Add = 'add'
}

export enum RouteParams {
	Id = 'id',
	Ids = 'ids',
	ChildId = 'childId',
	ReportTypeParam = 'reportType',
	RebateLoadFileId = 'rebateLoadFileId',
	SortTerm = 'sortTerm',
	SortAsc = 'sortAsc',
	CustomerIdParam = 'customerId',
	LobIds = 'lobIds',
	SubmissionPeriodIdParam = 'submissionPeriodId',
	IncludePhiData = 'includePhiData',
	RecentSubmissionsParam = 'recentSubmissions',
	StatisticsLevel = 'statisticsLevel',
	LocationIdParam = 'locationId',
	LocationNameParam = 'locationName',
	IsUserCustomers = 'isUserCustomers',
	Connection = 'connection',
	RebateRecordId = 'rebateRecordId',
	RebateRecordAggregationId = 'rebateRecordAggregationId',
	IsInvalidOnly = 'isInvalidOnly',
	ErrorCode = 'errorCode',
	RebateOperationsOwnerId = 'rebateOperationsOwnerId',
	AccountExecutive = 'accountExecutive'
}

export enum AccountRoutes {
	SignIn = 'sign-in',
	SignOut = 'sign-out',
	Profile = 'profile',
	NoPermissions = 'no-permissions',
	ConfirmAccount = 'confirm-account',
	ForgotPassword = 'forgot-password',
	ConfirmPasswordReset = 'confirm-password-reset',
	ConfirmPasswordChange = 'confirm-password-change'
}

export enum Auth0Routes {
	Callback = 'callback',
	AuthenticateError = 'authenticate-error',
	AccountLink = 'account-link'
}

export enum UserRoutes {
	Root = 'user-management',
	Users = 'users',
	Roles = 'roles'
}

export enum ReportRoutes {
	Root = 'reports'
}

export enum CustomerMonthlyDataRoutes {
	Root = 'customer-monthly-data',
	CustomerNotes = 'customer-notes',
	MonthlyScriptCount = 'monthly-script-count',
	ScriptCount = 'script-count',
	TotalWac = 'total-wac',
	FillDates = 'fill-dates'
}

export enum CustomerRoutes {
	Root = 'customers',
	CreateFacility = 'create-facility',
	UpdateFacility = 'update-facility',
	ContractPayment = 'contract-payment',
	Fees = 'fees',
	TechEnablementFee = 'tech-enablement-fee',
	CreateCustomerBdc = 'create-customer-bdc',
	UpdateCustomerBdc = 'update-customer-bdc',
	CreateCustomDateOfService = 'create-custom-dos',
	UpdateCustomDateOfService = 'update-custom-dos',
	CreateCustomerRebateGroup = 'create-customer-rebate-group',
	UpdateCustomerRebateGroup = 'update-customer-rebate-group',
	History = 'history',
	Notes = 'notes',
	RebateAggregatorAttributeValue = 'rebate-aggregator-attribute-value'
}

export enum AuditRoutes {
	Root = 'audit-log'
}

export enum FormularyNdcRoutes {
	Root = 'formulary-ndc'
}

export enum RebateAggregatorRoutes {
	Root = 'rebate-aggregators',
	Formulary = 'formulary',
	Attribute = 'attribute'
}

export enum MaintenanceRoutes {
	Root = 'maintenance'
}

export enum NotFoundRoutes {
	Root = 'not-found'
}

export enum SubmissionPeriodRoutes {
	Root = 'submission-period'
}

export enum RebateAggregatorNdcRateRoutes {
	Root = 'rebate-aggregator-ndc-rate',
	Create = 'create',
	Add = 'add',
	Update = 'update'
}

export enum RebatesLoadRoutes {
	Root = 'rebates-load',
	New = 'new',
	Mapping = 'mapping',
	InvalidRecords = 'invalid-records',
	WarningRecords = 'warning-records',
	Locations = 'locations',
	LocationsSummary = 'locations-summary',
	MissingLocations = 'missing-locations',
	FileDuplicates = 'file-duplicate',
	CrossFileDuplicates = 'cross-file-duplicate',
	Aggregations = 'aggregations',
	Conversions = 'conversions',
	Converted = 'converted',
	NotConverted = 'not-converted',
	CustomerNotes = 'customer-notes',
	PharmacyIdReview = 'pharmacy-id-review',
	InOutpatientDefinitionReview = 'in-outpatient-definition-review',
	FinalReview = 'final-review',
	Failures = 'failures',
	RawRecords = 'raw-records',
	Multiprocessing = 'multiprocessing'
}

export enum RebatesUpdateRoutes {
	Root = 'rebates-update',
	History = 'history'
}

export enum RebatesReSubmissionRoutes {
	Root = 'rebates-re-submission',
	New = 'upload'
}

export enum PayorRoutes {
	Root = 'payors',
	Reviewed = 'reviewed',
	NotReviewed = 'not-reviewed'
}

export enum LineOfBusinessRoutes {
	Root = 'line-of-business',
	Create = 'create',
	Edit = 'edit',
	Subtype = 'subtype'
}

export enum BdcRoutes {
	Root = 'bdc',
	Create = 'create'
}

export enum NdcReplacementMappingsRoutes {
	Root = 'ndc-replacement',
	Create = 'create'
}

export enum DownstreamClientIdAssociationRoutes {
	Root = 'downstream-client-id-association',
	Create = 'create'
}

export enum AberrantQuantityRoutes {
	Root = 'aberrant-quantities'
}

export enum UnbreakableQuantityRoutes {
	Root = 'unbreakable-quantities'
}

export enum RebateGroupRoutes {
	Root = 'rebate-groups',
	Formularies = 'formularies',
	Rules = 'rules',
	RebateAggregatorAttributeValue = 'rebate-aggregator-attribute-value'
}

export enum ExcludedPharmacyRoutes {
	Root = 'excluded-pharmacy'
}

export enum InOutpatientDefinitionRoutes {
	Root = 'in-outpatient-definition',
	Customer = 'customer'
}

export enum NonPatientExclusionRoutes {
	Root = 'non-patient-exclusion'
}

export enum ProcessingConfigRoutes {
	Root = 'processing-config'
}

export enum AuditEventsRoutes {
	Root = 'audit',
	RebatesLoad = 'rebates-load',
	AdminRecords = 'admin-records',
	Users = 'users',
	Roles = 'roles'
}

export enum RebateGroupAggregatorNdcRoutes {
	Root = 'ndc-destination',
	Create = 'create',
	Customer = 'customer',
	Files = 'files'
}

export enum SubmissionOverviewRoutes {
	Root = 'submission-overview'
}

export enum SubmissionFilesRoutes {
	Root = 'submission-files',
	SubmittedData = 'submitted-data'
}
